<template>
  <div class="flex h-full items-center tag-location-filters-big">
    <SearchField
      :class="className"
      :icon="SearchIcon"
      :options="tags"
      :model-value="form.eventType"
      placeholder="Event type"
      error-messages-in-tooltip
      @change="$emit('eventTypeChange', $event)"
    />
    <LocationField
      id="location-filters-big__location"
      class="ml-2"
      :class="className"
      :icon="PinIcon"
      :model-value="form.location"
      :clear-on-focus-value="NEAR_ME_LABEL"
      placeholder="Location"
      @change="$emit('locationChange', $event)"
    />
  </div>
</template>

<script>

import SearchIcon from '@tagvenue/icons/24/line/general/search-md.svg';
import PinIcon from '@tagvenue/icons/24/line/maps-travel/marker-pin-01.svg';
import { markRaw } from 'vue';

import LocationField from '@/components/Ui/Forms/LocationField.vue';
import SearchField from '@/components/Ui/Forms/SearchField.vue';
import { NEAR_ME_LABEL } from '@/constants/location';

export default {
  name: 'TagLocationFiltersBig',
  components: { SearchField, LocationField },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    eventTypeLabel: {
      type: String,
      required: true,
    },
    desktopOpen: {
      type: Boolean,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
    inputSize: {
      type: String,
      validator: size => ['big', 'small'].includes(size),
      default: 'big',
    },
  },

  data() {
    return {
      PinIcon: markRaw(PinIcon),
      SearchIcon: markRaw(SearchIcon),
      NEAR_ME_LABEL,
    };
  },

  computed: {
    className() {
      return this.inputSize === 'big' ? 'max-w-4xl' : 'max-w-2xl';
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@sass/design-system/variables" as ds-variables;

.tag-location-filters-big {
  min-width: 350px;
}
.tag-location-filters-big :deep(input) {
  background-color: ds-variables.$grey-100;
  border-color: ds-variables.$grey-100;
}
</style>
